<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="(apiLoaded || errorText) && ($user.role === 'ROLE_VNII' || $user.role === 'ROLE_MINTRUD' || $user.role === 'ROLE_ADMIN')">
        <div v-if="apiLoaded" class="wrap">
          <a @click="$router.go(-1)" class="back-link">
            <v-icon class="icon-item icon-chevron-left"></v-icon>
            Назад
          </a>
          <h1 v-if="configId == null" style="margin-bottom: 20px">
            Реестр отчетов
            <div class="download-menu">
              <v-dialog
                  v-model="dialog"
                  max-width="600px"
                  persistent>
                <template v-slot:activator="{ on }">
                  <div class="download" v-on="on">
                    <v-btn outlined>
                      экспорт
                    </v-btn>
                  </div>
                </template>
                <StandardReportExportDialog @close="dialog = false; dialogKey++" :key="dialogKey"/>
              </v-dialog>
            </div>
            <div>
              <h4>Тип среза:</h4>
              <v-radio-group v-model="format" row @change="onFormatChange">
                <v-radio label="По мониторингам" value="byReports"></v-radio>
                <v-radio label="По регионам или ЦЗН" value="byRegionsOrCzn"></v-radio>
              </v-radio-group>
            </div>
            <template v-if="format === 'byRegionsOrCzn'">
              <div>
                <h4>Уровень мониторинга:</h4>
                <v-radio-group v-model="level" row @change="loadData">
                  <v-radio label="Регионы" value="region"></v-radio>
                  <v-radio label="ЦЗН" value="czn"></v-radio>
                </v-radio-group>
              </div>
              <department-info v-if="level === 'czn'" @depObj="department = $event; loadData()"></department-info>
              <v-autocomplete
                  v-else
                  style="width: 500px; margin-top: 20px;"
                  dense
                  label="Регион"
                  :items="regionList"
                  item-text="name"
                  return-object
                  v-model="userRegion"
                  @input="loadData"
              ></v-autocomplete>
              <v-select
                  class="status-filter"
                  dense
                  label="Статус"
                  :items="statusFilterItems"
                  item-text="text"
                  item-value="value"
                  v-model="statusFilter"
                  hide-details
              ></v-select>
            </template>
            <template v-if="format === 'byReports'">
              <v-autocomplete
                  style="width: 500px; margin-top: 20px;"
                  dense
                  label="Мониторинг"
                  :items="sourceConfigs"
                  item-text="content.title"
                  return-object
                  v-model="config"
                  @input="loadData"
              ></v-autocomplete>
              <v-select
                  class="status-filter"
                  dense
                  label="Статус"
                  :items="statusFilterItems"
                  item-text="text"
                  item-value="value"
                  v-model="statusFilter"
                  hide-details
              ></v-select>
            </template>
          </h1>
          <h1 v-else style="margin-bottom: 20px">
            Реестр отчетов
            <div>
              <h4>
                {{ config.content.title }} [id{{ config.id }}]
              </h4>
            </div>
            <v-select
                class="status-filter"
                dense
                label="Статус"
                :items="statusFilterItems"
                item-text="text"
                item-value="value"
                v-model="statusFilter"
                hide-details
            ></v-select>
          </h1>

          <div class="hdr">Отчетные формы</div>
          <div v-if="fillStats" class="fill-stats">
            <div class="fill-stats__item">
              <span class="fill-stats__label">Всего</span>
              <span class="fill-stats__value">{{ fillStats.total }} {{ fillStats.unit }}</span>
            </div>
            <div class="fill-stats__item">
              <span class="fill-stats__label">Новая</span>
              <span class="fill-stats__value">{{ fillStats.notStarted }}</span>
            </div>
            <div class="fill-stats__item">
              <span class="fill-stats__label">Черновик</span>
              <span class="fill-stats__value">{{ fillStats.draft }}</span>
            </div>
            <div class="fill-stats__item">
              <span class="fill-stats__label">Отправлено</span>
              <span class="fill-stats__value">{{ fillStats.sent }}</span>
            </div>
          </div>
          <div class="list">
            <template>
              <table class="reports-table">
                <colgroup>
                  <col class="reports-table__col-name">
                  <col class="reports-table__col-date">
                  <col class="reports-table__col-date">
                  <col class="reports-table__col-status">
                </colgroup>
                <thead>
                <tr>
                  <th>{{ firstColumnLabel() }}</th>
                  <th>Дата создания</th>
                  <th>Дата отправки</th>
                  <th>Статус</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(row, index) in displayRows"
                    :key="'row-' + index + '-' + row.key"
                    :class="{'group-header': row.isGroupHeader}"
                >
                  <template v-if="row.isGroupHeader">
                    <td colspan="4">{{ row.name }}</td>
                  </template>
                  <template v-else>
                    <td>
                      <router-link v-if="row.report" :to="'/reports/' + row.report.id">
                        {{ row.name }}
                      </router-link>
                      <span v-else>{{ row.name }}</span>
                    </td>
                    <td v-if="row.report && row.report.createdDateTime">
                      <div>{{ row.report.createdDateTime | dateFormat }}</div>
                      <div>{{ row.report.createdDateTime | timeFormat }}</div>
                    </td>
                    <td v-else>—</td>
                    <td v-if="row.report && row.report.sendDateTime">
                      <div>{{ row.report.sendDateTime | dateFormat }}</div>
                      <div>{{ row.report.sendDateTime | timeFormat }}</div>
                    </td>
                    <td v-else>—</td>
                    <td>
                      <template v-if="row.report">{{ reportStatuses[row.report.status] }}</template>
                      <template v-else>Новая</template>
                    </td>
                  </template>
                </tr>
                </tbody>
              </table>
              <div v-if="displayRows.length === 0" style="height: 48px; margin-top: 20px">
                Не найдены отчетные формы
              </div>
            </template>
          </div>
        </div>
        <div v-if="errorText!=null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <loader-dialog :show="loading" msg="Загрузка"></loader-dialog>
  </div>
</template>

<script>
import StandardReportExportDialog from "@/components/standard_report/StandardReportExportDialog";
import departmentInfo from "@/components/elements/DepartmentInfo";
import api from "@/modules/api";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import {
  getFormsByDomainAndContext,
  getFormsByDomainAndCznIdAndContext,
  getFormsByDomainAndRegionCodeAndContext
} from "@/modules/api.forms";
import {getDomainConfigs} from "@/modules/api.configs";

export default {
  name: 'StandardReportRegistry',
  components: {
    LoaderDialog,
    departmentInfo,
    StandardReportExportDialog,
  },
  data: () => ({
    dialog: false,
    domain: 'standard_report',
    reports: [],
    configs: [],
    sourceConfigs: [],
    configId: null,
    config: null,
    dialogKey: 0,
    format: "byReports",
    level: "region",
    department: null,
    regionList: [],
    userRegion: {},
    reportStatuses: {
      DRAFT: "Черновик",
      SENT: "Отправлено"
    },
    statusFilter: 'ALL',
    apiLoaded: false,
    errorText: null,
    loading: null,
  }),
  computed: {
    statusFilterItems() {
      const items = [
        {value: 'ALL', text: 'Все'},
        {value: 'DRAFT', text: 'Черновик'},
        {value: 'SENT', text: 'Отправлено'},
      ]
      if (this.format === 'byReports') {
        items.splice(1, 0, {value: 'NOT_STARTED', text: 'Новая'})
      }
      return items
    },
    rawDisplayRows() {
      if (this.format === 'byReports') {
        return this.buildRowsByMonitoring()
      }
      return this.buildRowsByRegionOrCzn()
    },
    displayRows() {
      return this.filterRowsByStatus(this.rawDisplayRows)
    },
    fillStats() {
      if (this.format !== 'byReports' || !this.config) {
        return null
      }
      const rows = this.rawDisplayRows.filter(row => !row.isGroupHeader)
      if (rows.length === 0) {
        return null
      }
      return {
        total: rows.length,
        unit: this.entityUnitLabel(rows.length, this.config.content.type),
        notStarted: rows.filter(row => !row.report).length,
        draft: rows.filter(row => row.report && row.report.status === 'DRAFT').length,
        sent: rows.filter(row => row.report && row.report.status === 'SENT').length,
      }
    }
  },
  methods: {
    entityUnitLabel(count, type) {
      if (type === 'czn') {
        return 'ЦЗН'
      }
      const mod10 = count % 10
      const mod100 = count % 100
      if (mod10 === 1 && mod100 !== 11) {
        return 'регион'
      }
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return 'региона'
      }
      return 'регионов'
    },
    rowMatchesStatus(row) {
      if (this.statusFilter === 'ALL') {
        return true
      }
      if (this.statusFilter === 'NOT_STARTED') {
        return !row.report
      }
      return row.report && row.report.status === this.statusFilter
    },
    filterRowsByStatus(rows) {
      if (this.statusFilter === 'ALL') {
        return rows
      }

      const result = []
      let currentGroup = null
      let groupItems = []

      const flushGroup = () => {
        if (groupItems.length > 0) {
          if (currentGroup) {
            result.push(currentGroup)
          }
          result.push(...groupItems)
        }
        currentGroup = null
        groupItems = []
      }

      for (const row of rows) {
        if (row.isGroupHeader) {
          flushGroup()
          currentGroup = row
        } else if (this.rowMatchesStatus(row)) {
          groupItems.push(row)
        }
      }
      flushGroup()
      return result
    },
    compareNames(a, b) {
      return (a || '').localeCompare(b || '', 'ru', {sensitivity: 'base'})
    },
    onFormatChange() {
      if (this.format !== 'byReports' && this.statusFilter === 'NOT_STARTED') {
        this.statusFilter = 'ALL'
      }
      this.loadData()
    },
    async loadConfigs() {
      this.sourceConfigs = (await getDomainConfigs(this.domain)).payload
      this.sourceConfigs.sort((a, b) => (a.createdDate < b.createdDate) ? 1 : -1)
    },
    async loadData() {
      this.loading = true
      await this.processConfigs()
      await this.loadReports()
      this.loading = false
    },
    async processConfigs() {
      this.configs = [...this.sourceConfigs]

      if (this.format === "byReports") {
        if (this.config) {
          this.configs = this.configs.filter(config => config.id === this.config.id)
        } else {
          this.configs = []
        }
      }

      if (this.format === "byRegionsOrCzn") {
        if (this.level === 'region') {
          this.configs = this.configs.filter(config => config.content.regions.includes(this.userRegion.code))
        }
        if (this.level === 'czn') {
          this.configs = this.configs.filter(config => config.content.czns.includes(this.department?.id))
        }
        this.configs.sort((a, b) => this.compareNames(a.content?.title, b.content?.title))
      }
    },
    async loadReports() {
      this.reports = []
      for (const config of this.configs) {
        let reports = []

        if (this.format === 'byReports') {
          reports = (await getFormsByDomainAndContext(
              this.domain,
              config.content.context
          )).payload
        }

        if (this.format === 'byRegionsOrCzn') {
          if (this.level === 'region') {
            reports = (await getFormsByDomainAndRegionCodeAndContext(
                this.domain,
                this.userRegion.code,
                config.content.context
            )).payload
          }

          if (this.level === 'czn') {
            reports = (await getFormsByDomainAndCznIdAndContext(
                this.domain,
                this.department.id,
                config.content.context
            )).payload
          }
        }

        this.reports = this.reports.concat(reports.filter(newReport =>
            !this.reports.some(existingReport => existingReport.id === newReport.id)
        ))
      }
    },
    async getRegionList() {
      let req = await api.get("/getRegionsList");
      if (req.ok) {
        this.regionList = req.payload;
        this.regionList.sort((a, b) => this.compareNames(a.name, b.name));
      } else {
        console.log('get regionList error');
      }
    },
    pickReport(matches) {
      if (!matches || matches.length === 0) {
        return null
      }
      if (matches.length === 1) {
        return matches[0]
      }
      const statusOrder = {SENT: 2, DRAFT: 1}
      return [...matches].sort((a, b) => {
        const statusDiff = (statusOrder[b.status] || 0) - (statusOrder[a.status] || 0)
        if (statusDiff !== 0) {
          return statusDiff
        }
        return new Date(b.createdDateTime || 0) - new Date(a.createdDateTime || 0)
      })[0]
    },
    findReportByRegionCode(regionCode) {
      return this.pickReport(this.reports.filter(report => report.regionCode === regionCode))
    },
    findReportByCznId(cznId) {
      return this.pickReport(this.reports.filter(report => report.cznId === cznId))
    },
    getRegionByCznId(cznId) {
      return this.$cznDepartmentsByRegionList.find(region =>
          region.departments.some(department => department.id === cznId)
      )
    },
    uniqueCodes(values) {
      const result = []
      const seen = new Set()
      for (const value of values || []) {
        const code = value == null ? '' : String(value).trim()
        if (!code || seen.has(code)) {
          continue
        }
        seen.add(code)
        result.push(code)
      }
      return result
    },
    buildRowsByMonitoring() {
      if (!this.config) {
        return []
      }

      if (this.config.content.type === 'region') {
        return this.uniqueCodes(this.config.content.regions)
            .map(code => {
              const name = this.getRegionNameByCode(code) || code
              return {
                key: 'region-' + code,
                name,
                report: this.findReportByRegionCode(code),
                isGroupHeader: false,
              }
            })
            .sort((a, b) => this.compareNames(a.name, b.name))
      }

      if (this.config.content.type === 'czn') {
        const groups = new Map()
        const cznIds = this.uniqueCodes(this.config.content.czns)

        for (const cznId of cznIds) {
          const numericId = Number(cznId)
          const lookupId = Number.isNaN(numericId) ? cznId : numericId
          const region = this.getRegionByCznId(lookupId) || this.getRegionByCznId(cznId)
          const regionKey = region?.code || 'unknown'
          const regionName = region?.name || 'Без региона'
          if (!groups.has(regionKey)) {
            groups.set(regionKey, {
              key: regionKey,
              name: regionName,
              rows: [],
            })
          }
          groups.get(regionKey).rows.push({
            key: 'czn-' + cznId,
            name: this.getCznNameByCznId(lookupId) || this.getCznNameByCznId(cznId),
            report: this.findReportByCznId(lookupId) || this.findReportByCznId(cznId),
            isGroupHeader: false,
          })
        }

        const result = []
        const sortedGroups = Array.from(groups.values())
            .sort((a, b) => this.compareNames(a.name, b.name))

        for (const group of sortedGroups) {
          group.rows.sort((a, b) => this.compareNames(a.name, b.name))
          result.push({
            key: 'group-' + group.key,
            name: group.name,
            isGroupHeader: true,
          })
          result.push(...group.rows)
        }
        return result
      }

      return []
    },
    buildRowsByRegionOrCzn() {
      return this.reports
          .map(report => {
            const config = this.sourceConfigs.find(item => item.content.context === report.context)
            return {
              key: 'report-' + report.id,
              name: config?.content?.title || report.context,
              report,
              isGroupHeader: false,
            }
          })
          .sort((a, b) => this.compareNames(a.name, b.name))
    },
    firstColumnLabel() {
      if (this.format === 'byRegionsOrCzn') {
        return 'Наименование'
      }
      if (this.config?.content?.type === 'region') {
        return 'Регионы'
      }
      if (this.config?.content?.type === 'czn') {
        return 'ЦЗН'
      }
      return 'Наименование'
    },
    getRegionNameByCode(regionCode) {
      return this.$cznDepartmentsByRegionList.find(r => r.code === regionCode)?.name
          || this.regionList.find(r => r.code === regionCode)?.name
    },
    getCznNameByCznId(cznId) {
      for (const region of this.$cznDepartmentsByRegionList) {
        const department = region.departments.find(c => c.id === cznId);
        if (department) {
          return department.name;
        }
      }
      return String(cznId);
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    },
    timeFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', hour: '2-digit', minute: '2-digit'}
      return mdate.toLocaleTimeString('ru-RU', options)
    }
  },
  async beforeMount() {
    await this.loadConfigs()

    this.configId = this.$route.params.configId
    if (this.configId != null) {
      this.format = "byReports"
      this.config = this.sourceConfigs.find(config => config.id === this.configId)
    } else {
      await this.getRegionList()
      this.userRegion = this.regionList[0]
      this.config = this.sourceConfigs[0]
    }

    await this.loadData()
    this.apiLoaded = true
  }
}
</script>

<style scoped lang="scss">
.hdr {
  margin-top: 8px;
  margin-bottom: 12px;
}

.status-filter {
  width: 500px;
  margin-top: 12px;
  margin-bottom: 0;
}

.fill-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 0 0 16px;
  padding: 12px 16px;
  background: #F5F8FC;

  &__item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 88px;
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: #5C5C61;
  }

  &__value {
    font-size: 16px;
    font-weight: 600;
    color: #1C1C1F;
  }
}

.wrap > h1 > div:not(.download-menu) {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 8px;
  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    color: #1C1C1F;
  }
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
  .v-input--selection-controls .v-radio > .v-label {
    font-size: 15px;
  }
  > div {
    &:first-child {
      margin-right: 77px;
    }
  }
}

.list {
  table {
    border-collapse: collapse;
    width: 100%;

    th {
      border-bottom: 1px solid #E8E8E9;
    }

    td {
      padding: 10px 8px;
      vertical-align: middle;
    }
  }
}

.reports-table {
  table-layout: fixed;

  &__col-name {
    width: auto;
  }

  &__col-date {
    width: 155px;
  }

  &__col-status {
    width: 140px;
  }

  th,
  td {
    padding: 10px 8px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  th {
    vertical-align: top;
    white-space: normal;
    line-height: 1.25;
    font-weight: 600;
  }

  td {
    vertical-align: top;
  }

  td:not(:first-child) {
    white-space: nowrap;
  }

  .group-header td {
    font-weight: 600;
    background: #F5F8FC;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

.download-menu {
  top: 0;
  margin-top: 0;
}

</style>

<style>
.v-input--radio-group__input {
  justify-content: flex-start !important;
  align-items: flex-start !important;
}
</style>

<style lang="scss">
@import "../../styles/main.scss";
</style>
